const isJsonResponse = (response: any): boolean => {
    const contentType = response.headers.get('content-type');

    return (contentType && contentType.includes('application/json') === true);
};

export default isJsonResponse;
